import * as React from "react";
import './_header-content.scss';
import {isEmpty} from "lodash";
import {GatsbyImage} from "gatsby-plugin-image";

const HeaderContent = ({...props}) => {

  const atomClassName = 'header-content';
  var atomClass = props?.className !== undefined ? atomClassName + ' ' + props.className : atomClassName;

  return (
    <div className={atomClass} {...props}>
      <div className="row">
        <div className="col-12">
          <div className={"position-relative"}>
            {!isEmpty(props?.image) ? (
              <GatsbyImage className="w-100 rounded-2"
                           image={props?.image?.node?.gatsbyImage || props?.image?.gatsbyImage}
                           alt={"header image"}/>
            ) : null}
            <div className="position-absolute top-0 w-100 text-overlay">
              <div className="inner d-flex flex-column gap-1">
                <p className="fs-12 text-center text-white text-uppercase mb-0">{props?.pretitle}</p>
                <h1 className="h1 text-center text-white fw-bold mb-0">{props?.title}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default HeaderContent
